<app-user-menu [orgId]="orgId"></app-user-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <ng-container *ngIf="reservationSettings.enablePaymentReservation === false">
        <div class="row mt-3">
            <div class="col text-center">
                <strong class="text-warning">
                    {{'USER.RESERVATIONS.activationMessage' | translate}}
                </strong><br />
                <a class="btn btn-primary mt-3" href="mailto:info@lidonews.it">E-Mail</a>
            </div>
        </div>
    </ng-container>
    <div class="row" *ngIf="reservationSettings.enablePaymentReservation">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="form-group d-flex align-items-center justify-content-between m-0">
                        <span>{{'USER.RESERVATIONS.normalReservation' | translate}}</span>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="switchReservation"
                                [(ngModel)]="reservationSettings.enableReservation"
                                [checked]="reservationSettings.enableReservation"
                                (change)="onReservationTypeChange(0, $event)" />
                            <label class="custom-control-label" for="switchReservation"></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="form-group d-flex align-items-center justify-content-between m-0">
                        <span>{{'USER.RESERVATIONS.slotReservation' | translate}}</span>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="switchSlotReservation"
                                [(ngModel)]="reservationSettings.enableSlotReservation"
                                [checked]="reservationSettings.enableSlotReservation"
                                (change)="onReservationTypeChange(3, $event)" />
                            <label class="custom-control-label" for="switchSlotReservation"></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col">
            <ng-container *ngIf="reservationSettings.enableReservation;">
                <app-simple-reservations [settings]="reservationSettings.normalReservation"></app-simple-reservations>
            </ng-container>
            <ng-container *ngIf="reservationSettings.enableSlotReservation;">
                <app-slot-reservations [settings]="reservationSettings.slotReservation"></app-slot-reservations>
            </ng-container>
        </div>
    </div>
</div>